import { FlagIcon, PlusIcon } from '@heroicons/react/20/solid'
import mobilityIcon from 'media/icons/mobility.png'

const textGray800Hex = '#101828'
const svgIconSizeClassName = 'w-4 h-4 2xl:w-5 2xl:h-5'

export default function MicroVolumeStimulusTypeIcon({ 
    iconKey=null 
}) {

    if (iconKey === null) return null

    return (
        <div className='w-full flex items-center justify-center pb-1 2xl:pb-1.5'>
            {iconKey === 'flag' && (
                <FlagIcon className={svgIconSizeClassName + ' text-gray-900'} data-testid='micro-volume-event-flag' />
            )}

            {iconKey === 'plus-icon' && (
                <PlusIcon className='w-4 h-4 2xl:w-6 2xl:h-6 text-gray-900 2xl:-mb-0.5' />
            )}

            {iconKey === 'up-arrow' && (
                <svg 
                    className={svgIconSizeClassName}
                    viewBox='0 0 18 18' 
                    fill='none' 
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M9 2.5C9.3806 2.5 9.73638 2.70485 9.92068 3.03325L15.5076 12.9158C15.8161 13.4629 15.4133 14.125 14.7621 14.125H3.23785C2.5867 14.125 2.18395 13.4629 2.49241 12.9158L8.07932 3.03325C8.26362 2.70485 8.6194 2.5 9 2.5Z'
                        fill={textGray800Hex}
                    />
                </svg>
            )}

            {iconKey === 'diamond' && (
                <svg 
                    className={svgIconSizeClassName}
                    viewBox='0 0 18 18' 
                    fill='none' 
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <polygon 
                        points='9,3 15,9 9,15 3,9' 
                        fill={textGray800Hex} 
                    />
                </svg>
            )}

            {iconKey === 'down-arrow' && (
                <svg 
                    className={svgIconSizeClassName}
                    viewBox='0 0 18 18' 
                    fill='none' 
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M9 2.5C9.3806 2.5 9.73638 2.70485 9.92068 3.03325L15.5076 12.9158C15.8161 13.4629 15.4133 14.125 14.7621 14.125H3.23785C2.5867 14.125 2.18395 13.4629 2.49241 12.9158L8.07932 3.03325C8.26362 2.70485 8.6194 2.5 9 2.5Z'
                        transform='rotate(180 9 9)'
                        fill={textGray800Hex}
                    />
                </svg>
            )}

            {iconKey === 'mobility-icon' && (
                <img 
                    src={mobilityIcon} 
                    alt="Mobility" 
                    className="w-3 h-3 2xl:w-4 2xl:h-4" 
                />
            )}
        </div>
    )
}
